import { createAuthClient } from "better-auth/client";

/**
 * Auth client for the web app. baseURL defaults to window.location.origin,
 * so /api/auth/* calls are same-origin and reach the Worker through the
 * Pages Function proxy in production (and the vite proxy in dev) — that's
 * what keeps the session cookie first-party.
 */
export const authClient = createAuthClient();
